import {Coach} from "../../src/interfaces/interfaces";
import {TrenerskaTrida} from "../../src/interfaces/enums";

const coaches : Coach[] = [
    {
        level: TrenerskaTrida.trida1,
        name: 'Kapounková Kateřina',
    },
    {
        level: TrenerskaTrida.trida1,
        name: 'Langová Hanne',
    },
    {
        level: TrenerskaTrida.baletniPedagog,
        name: 'Dvořák Kamil',
    },
    {
        level: TrenerskaTrida.trida2,
        name: 'Bohuslavová Simona',
    },
    {
        level: TrenerskaTrida.trida2,
        name: 'Bubníková Hanna',
    },
    {
        level: TrenerskaTrida.trida2,
        name: 'Kapounková Karolína',
    },
    {
        level: TrenerskaTrida.trida2,
        name: 'Langová Jiřina',
    },
    {
        level: TrenerskaTrida.trida2,
        name: 'Pavlíková Michaela',
    },
    {
        level: TrenerskaTrida.trida2,
        name: 'Štaudrová Petra',
    },
    {
        level: TrenerskaTrida.trida2,
        name: 'Urbancová Markéta',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Dohnalová Kristýna',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Dohnalová Šárka',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Sládková Nicol',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Studňařová Kateřina',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Suchomelová Dana',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Surková Iva',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Šnajdárová Eva',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Trgalová Helena',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Vágnerová Lenka',
    },
    {
        level: TrenerskaTrida.instruktor,
        name: 'Klempířová Pavlína',
    },
    {
        level: TrenerskaTrida.instruktor,
        name: 'Kozílková Lucie',
    },
    {
        level: TrenerskaTrida.instruktor,
        name: 'Kusalová Lada',
    },
    {
        level: TrenerskaTrida.instruktor,
        name: 'Rybková Kristina',
    },
]

export default coaches